import axios from 'axios';

export default ({ email }) => {
  return axios.post(`${process.env.VUE_APP_API_ENDPOINT}/persons/password-reset`, {
    email: email,
  });
};
